function l(n) {
  return n == null || n === void 0;
}
export {
  l as isNill
};
